<template>
	<div class="banner-management">
		<el-card>
			<div slot="header" class="clearfix">
				<span>轮播图管理</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="showAddDialog">
					添加轮播图
				</el-button>
			</div>

			<el-tabs v-model="activePosition" @tab-click="handleTabClick">
				<el-tab-pane label="首页顶部轮播" name="1"></el-tab-pane>
				<el-tab-pane label="首页中部轮播" name="2"></el-tab-pane>
			</el-tabs>

			<el-table :data="bannerList" border style="width: 100%">
				<el-table-column prop="id" label="ID" width="80"></el-table-column>
				<el-table-column label="轮播图" width="180">
					<template slot-scope="scope">
						<el-image style="width: 150px; height: 80px" :src="scope.row.image_url" fit="contain"
							:preview-src-list="[scope.row.image_url]"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="title" label="标题"></el-table-column>
				<el-table-column prop="sort_order" label="排序" width="100"></el-table-column>
				<el-table-column label="状态" width="100">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.is_active" :active-value="1" :inactive-value="0"
							@change="handleStatusChange(scope.row)"></el-switch>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="180">
					<template slot-scope="scope">
						<el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
			</el-pagination>
		</el-card>

		<!-- 添加/编辑对话框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" @close="resetForm">
			<el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
				<el-form-item label="轮播位置" prop="position">
					<el-radio-group v-model="form.position">
						<el-radio :label="1">首页顶部轮播</el-radio>
						<el-radio :label="2">首页中部轮播</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="轮播标题" prop="title">
					<el-input v-model="form.title"></el-input>
				</el-form-item>
				<el-form-item label="轮播图片" prop="image_url">
					<el-upload class="avatar-uploader" action="https://www.fossnet.cn/api/upload.php"
						:show-file-list="false" :on-success="handleUploadSuccess" :before-upload="beforeUpload">
						<img v-if="form.image_url" :src="form.image_url" class="avatar" />
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="跳转链接">
					<el-input v-model="form.link_url" placeholder="可选"></el-input>
				</el-form-item>
				<el-form-item label="排序权重">
					<el-input-number v-model="form.sort_order" :min="0" :max="999"></el-input-number>
				</el-form-item>
				<el-form-item label="是否启用">
					<el-switch v-model="form.is_active" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		apiBaseUrl
	} from '@/config';
	export default {
		data() {
			return {
				activePosition: "1",
				bannerList: [],
				pagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0,
				},
				dialogVisible: false,
				dialogTitle: "添加轮播图",
				form: {
					id: "",
					title: "",
					image_url: "",
					link_url: "",
					position: 1,
					sort_order: 0,
					is_active: 1,
				},
				rules: {
					title: [{
						required: true,
						message: "请输入标题",
						trigger: "blur"
					}],
					image_url: [{
						required: true,
						message: "请上传图片",
						trigger: "change"
					}, ],
					position: [{
						required: true,
						message: "请选择轮播位置",
						trigger: "change"
					}, ],
				},
				isEdit: false,
			};
		},
		created() {
			this.fetchBannerList();
		},
		methods: {
			async fetchBannerList() {
				try {
					const response = await fetch(`${apiBaseUrl}/banners.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							action: 'list',
							position: this.activePosition,
							page: this.pagination.currentPage,
							pageSize: this.pagination.pageSize,
						}),
					});


					const data = await response.json();

					if (data.success) {
						this.bannerList = data.data;
						this.pagination.total = parseInt(data.total);
					} else {
						throw new Error(data.message || '获取轮播图列表失败');
					}
				} catch (error) {
					this.$message.error(error.message);
					console.error('Error fetching banners:', error);
				}
			},
			handleTabClick() {
				this.pagination.currentPage = 1;
				this.fetchBannerList();
			},
			handleSizeChange(val) {
				this.pagination.pageSize = val;
				this.fetchBannerList();
			},
			handleCurrentChange(val) {
				this.pagination.currentPage = val;
				this.fetchBannerList();
			},
			showAddDialog() {
				this.dialogTitle = "添加轮播图";
				this.isEdit = false;
				this.dialogVisible = true;
			},
			handleEdit(row) {
				this.dialogTitle = "编辑轮播图";
				this.isEdit = true;
				this.form = {
					...row
				};
				this.dialogVisible = true;
			},
			async handleStatusChange(row) {
				try {
					const response = await fetch(`${apiBaseUrl}/banners.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							action: 'update',
							id: row.id,
							is_active: row.is_active,
						}),
					});

					const data = await response.json();

					if (!data.success) {
						throw new Error(data.message || '状态更新失败');
					}

					this.$message.success('状态更新成功');
				} catch (error) {
					this.$message.error(error.message);
					// 恢复原状态
					row.is_active = row.is_active === 1 ? 0 : 1;
				}
			},
			async handleDelete(id) {
				try {
					await this.$confirm("确定要删除该轮播图吗?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					});

					const response = await fetch(`${apiBaseUrl}/banners.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							action: 'delete',
							id: id,
						}),
					});

					const data = await response.json();

					if (!data.success) {
						throw new Error(data.message || '删除失败');
					}

					this.$message.success('删除成功');
					this.fetchBannerList();
				} catch (error) {
					if (error !== 'cancel') {
						this.$message.error(error.message);
					}
				}
			},
			async submitForm() {
				try {
					const valid = await this.$refs.form.validate();
					if (!valid) return;

					const action = this.isEdit ? 'update' : 'add';
					const payload = {
						...this.form,
						action
					};

					const response = await fetch(`${apiBaseUrl}/banners.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(payload),
					});

					const data = await response.json();

					if (!data.success) {
						throw new Error(data.message || (this.isEdit ? '更新失败' : '添加失败'));
					}

					this.$message.success(this.isEdit ? '更新成功' : '添加成功');
					this.dialogVisible = false;
					this.fetchBannerList();
				} catch (error) {
					this.$message.error(error.message);
				}
			},
			resetForm() {
				this.$refs.form.resetFields();
				this.form = {
					id: "",
					title: "",
					image_url: "",
					link_url: "",
					position: 1,
					sort_order: 0,
					is_active: 1,
				};
			},
			handleUploadSuccess(response) {
				// 根据你的上传接口返回结构调整
				this.form.image_url = apiBaseUrl + '/' + response.data.path;
				this.$refs.form.validateField("image_url");
			},
			beforeUpload(file) {
				const isImage = file.type.startsWith("image/");
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isImage) {
					this.$message.error("上传文件只能是图片格式!");
				}
				if (!isLt2M) {
					this.$message.error("上传图片大小不能超过 2MB!");
				}
				return isImage && isLt2M;
			},
		},
	};
</script>

<style scoped>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>